import { up, down, between, only, width } from './breakpoints';

export { up, down, between, only, width };
